/* ---------------------------------------------------------------------------
(c) 2023-2023, HID Global Corporation, part of ASSA ABLOY.
All rights reserved.

This program is an un published copyrighted work which is proprietary
to HID Global Corporation. This computer program includes Confidential,
Proprietary Information and is a Trade Secret of HID Global Corporation.
Any use, disclosure, modification and/or reproduction is prohibited
unless authorized in writing by HID Global Corporation.

WARNING:  Unauthorized reproduction of this program as well as
unauthorized preparation of derivative works based upon the
program or distribution of copies by sale, rental, lease or
lending are violations of federal copyright laws and state trade
secret laws, punishable by civil and criminal penalties.
--------------------------------------------------------------------------- */
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, output } from '@angular/core';

@Component({
    selector: 'app-notification',
    imports: [CommonModule],
    templateUrl: './notification.component.html',
    styleUrl: './notification.component.scss'
})
export class NotificationComponent {
  @Input() type: 'info' | 'error' | 'success' | 'warning' = 'info';
  @Input() title: string = '';
  @Input() subtitle: string = '';
  @Input() inline: boolean = false;
  @Input() close: boolean = false;
  @Output() closeNotification = new EventEmitter<boolean>();

  onClose(): void {
    this.closeNotification.emit(true);
  }
}
